import { RollForwardProfile } from "PFApp/components/rollforward/roll_forward_profile";
import { Inline, Stack } from "PFComponents/containers";
import { Divider } from "PFComponents/divider";
import { RollforwardProfile } from "PFCore/types";
import { Fragment } from "react";

import css from "./rollforward_info_section.module.scss";

type RollforwardProfilesProps = {
  profiles: RollforwardProfile[];
  mode?: "button" | "link";
  onProfileClick?: (profile: RollforwardProfile) => void;
  isVertical?: boolean;
};

export const RollforwardProfiles = ({
  profiles,
  mode,
  onProfileClick,
  isVertical
}: RollforwardProfilesProps) => {
  const Container = isVertical ? Stack : Inline;

  return (
    <Container alignItems={isVertical ? "start" : "center"}>
      {profiles.map((rollforwardProfile, index) => {
        const isLastItem = index === profiles.length - 1;
        const showDivider = !isVertical && profiles.length > 1 && !isLastItem;

        return (
          <Fragment key={rollforwardProfile.id}>
            <RollForwardProfile
              profile={rollforwardProfile}
              mode={mode}
              onClick={onProfileClick ? () => onProfileClick(rollforwardProfile) : undefined}
            />
            {showDivider && <Divider type="vertical" className={css.divider} />}
          </Fragment>
        );
      })}
    </Container>
  );
};
